import React from "react";
import { ToastContainer } from "react-toastify";
import AppRouter from "./routes/AppRouter";
import { SessionProvider } from "./context/SessionContext";
import useCheckAppVersion from "./hooks/useCheckAppVersion";

function App() {
	useCheckAppVersion(60000);

	return (
		<SessionProvider>
			<AppRouter />
			<ToastContainer
				position="top-center"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={true}
				closeOnClick={false}
				rtl={false}
				pauseOnFocusLoss
				draggable
				stacked
				pauseOnHover
				theme="light"
				closeButton={false}
			/>
		</SessionProvider>
	);
}

export default App;
